import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  selectSelectedFilter,
  selectComments
} from '../CommentState/selectors';

export const useFilteredComments = () => {
  const comments = useSelector(selectComments);
  const selectedFilter = useSelector(selectSelectedFilter);
  const filteredComments = useMemo(() => {
    if (!selectedFilter || !selectedFilter.item || comments.length === 0) {
      return []; //return empty array if no filter selected or comments are empty
    }
    if (selectedFilter?.key === 'totalComments') {
      return comments; // return all comments
    }
    if (selectedFilter?.item?.label === 'Resolved') {
      return comments.filter(comment => comment.commentStatus === 'RESOLVED');
    }
    // Determine section and sectionCategory based on filterLabel
    let expectedSection: string;
    let expectedSectionCategory: string;

    if (selectedFilter.filterLabel) {
      // filterLabel exists: section = filterLabel, sectionCategory = item.label
      expectedSection = selectedFilter.filterLabel;
      expectedSectionCategory = selectedFilter.item.label;
    } else {
      // filterLabel is undefined/null: section = "Overall", sectionCategory = item.label
      expectedSection = selectedFilter?.item?.label;
      expectedSectionCategory = selectedFilter?.item?.label;
    }
    return comments.filter(comment => {
      const commentSection = comment.section;
      const commentSectionCategory = comment.sectionCategory;

      // Check if comment matches both section and sectionCategory
      return (
        commentSection === expectedSection &&
        commentSectionCategory === expectedSectionCategory
      );
    });
  }, [comments, selectedFilter]);

  return filteredComments;
};
